/**
 * Created by Daniela on 29/09/2016.
 */
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'Gtin13Mask'
})
export class Gtin13Pipe implements PipeTransform {
    transform(value: any, args: number): any {
        if (value) {
            if (typeof value !== 'string') {
                value = value.toString();
            }

            value = value.replace(/\D/g, '');
            
            if(value.length === 13) {
                value = value.replace(/(\d{1})(\d{6})(\d{6})/, "$1 $2 $3");
            }
            
            return value;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/gtin-13.pipe.ts
 **/